import referralService from '@/store/services/referralService'

const state = {
  field: {
    amount: null,
    partner_id: null,
    paginate: 10,
  },
  metaReferral: null,
  partner_field: null,
  refreshReferralCount: 0,
}

const getters = {
  referrals: state => (state.metaReferral ? state.metaReferral.data : []),
  current_page: state => (state.metaReferral ? state.metaReferral.current_page : 0),
  last_page: state => (state.metaReferral ? state.metaReferral.last_page : 0),
  per_page: state => (state.metaReferral ? state.metaReferral.per_page : 0),
  total: state => (state.metaReferral ? state.metaReferral.total : 0),
}

const actions = {
  getReferralsList({ commit, state }, { page, field }) {
    if (state.metaReferral && state.metaReferral.current_page === page
        && state.partner_field === field.partner_id) return state.metaReferral

    return referralService.getReferrals(page, field).then(({ data }) => {
      commit('SET_META_REFERRAL', data.result)
      commit('SET_PARTNER_FIELD', field.partner_id)
      commit('SET_FIELD', field)
      return data
    })
  },
}

const mutations = {
  SET_META_REFERRAL(state, metaReferral) {
    state.metaReferral = metaReferral
  },
  SET_PARTNER_FIELD(state, partner_id) {
    state.partner_field = partner_id
  },
  SET_FIELD(state, field) {
    state.field = field
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
